<template>
    <div id="app" class="app" :class="{'app-haveLogo': showLogo, 'app-haveBurger': showBurger}">
        <MainLogo :is-white="logoIsWhite"></MainLogo>
        <Menu></Menu>
        <router-view />
    </div>
</template>


<script>
    import Menu from './components/Menu.vue';
    import MainLogo from './components/MainLogo.vue';
    import {SoundManager} from "./utils/SoundManager";
    export default {
        components: {MainLogo, Menu},
        metaInfo() {
          return {
            meta: [
              this.getMetaRobots()
            ]
          }
        },
        data(){
            return {
                showLogo: true,
                showBurger: true,
                logoIsWhite: false,
            }
        },
        methods: {
            checkLogoAndBurger: function(){
                this.showLogo = !('hideLogo' in this.$route.meta);
                this.showBurger = !('hideLogo' in this.$route.meta);
            },
            getMetaRobots: function(){
              if (this.$route.name !== 'home') {
                return {name: 'robots', content: 'noindex,nofollow'}
              } else {
                return {name: 'robots', content: 'index,follow'}
              }
            }
        },
        mounted () {
            //  [App.vue specific] When App.vue is finish loading finish the progress bar
            this.checkLogoAndBurger();


            // pouvoir changer la couleur du logo, un peu de partout
            this.$events.on('app-whitelogo', () => {
                this.logoIsWhite = true;
            });
            this.$events.on('app-darklogo', () => {
                this.logoIsWhite = false;
            });

            // quand on ouvre le menu principale, on force l'affichage du burger + logo
            this.$events.on('menu-isOpening', () => {
                this.showBurger = true;
                this.showLogo = false;
            });
            // quand on ferme le menu principal, on regarde si la page doit afficher ou non le burger + logo
            this.$events.on('menu-isClosing', () => {
                this.checkLogoAndBurger();
            });

        },
        created () {
            //  hook the progress bar to start before we move router-view
            this.$router.beforeEach((to, from, next) => {
                this.$events.fire('page-unlockScroll');
                // on pause les sons
                SoundManager.instance.stopAmbiance();
                //  continue to next page
                next();
            });
            //  hook the progress bar to finish after we've finished moving router-view
            this.$router.afterEach((to, from) => {
                this.checkLogoAndBurger();
            })
        }
    };
</script>

<style lang="scss">

    .app{

        height: 100vh;
        width: 100%;
        overflow: hidden;

        & > .mainLogo{
            position: fixed;
            left: $G-default;
            top: $G-default;
            z-index: $ZI-menuBtn;
            @include transition();
        }


        & > .mainLogo,
        .menu_btn{
            opacity: 0;
            transform: translateY(-20px);
            pointer-events: none;
            @include transition(all, 1.5s);
        }

        &-haveBurger .menu_btn,
        &-haveLogo > .mainLogo{
            opacity: 1;
            transform: translateY(0);
            pointer-events: all;
        }

    }

</style>
